import marketPlaces from '../constants/MarketPlaces';
import themeServices from '../themes/ThemeServices';
import marketplacePropertiesService from './MarketplacePropertiesService';

const defaults = {
    useFixedTopStimulus: true,
};

const overrides = {
    cxc: { useFixedTopStimulus: false },
};

const marketplaceSettingsService = {
    defaults,
    marketplace: null,
    overrides,
    settings: null,

    getMarketplaceName(marketplace) {
        let themeName = marketplacePropertiesService.getUiTheme();

        if (themeServices.isThemeOld(themeName)) {
            themeName = themeName.slice(0, -4);
        }

        if (marketPlaces[themeName]) {
            return marketPlaces[themeName];
        }
        return marketplace;
    },

    setMarketplace(marketplace) {
        this.marketplace = this.getMarketplaceName(marketplace);
    },

    getMarketplace() {
        return this.marketplace;
    },

    buildSettings() {
        if (this.marketplace === 'default') {
            this.settings = defaults;
            return;
        }

        const custom = overrides[this.marketplace] || {};
        this.settings = { ...defaults, ...custom };
    },

    getSettings() {
        if (this.settings === null) {
            this.buildSettings();
        }
        return this.settings;
    },

    useFixedTopStimulus() {
        return this.getSettings().useFixedTopStimulus;
    },
};

export default marketplaceSettingsService;
